import React from 'react';


const Dashboard = () => {
    return (
        <div className="d-flex justify-content-between">
            <div className="bg-success p-5 text-light shadow border rounded">
                <h2>Total service</h2>
            </div>
            <div className="bg-success p-5 text-light shadow border rounded">
                <h2>Total service</h2>
            </div>
            <div className="bg-success p-5 text-light shadow border rounded">
                <h2>Total service</h2>
            </div>
        </div>
    );
};

export default Dashboard;